import { render, staticRenderFns } from "./TheClientBox.vue?vue&type=template&id=038b8fb6&scoped=true"
import script from "./TheClientBox.vue?vue&type=script&lang=js"
export * from "./TheClientBox.vue?vue&type=script&lang=js"
import style0 from "./TheClientBox.vue?vue&type=style&index=0&id=038b8fb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038b8fb6",
  null
  
)

export default component.exports